import { sellerAxiosInstance } from 'silal_app_base_react/src/utils/axios/axios';
import { AuthenticatedApiRepository } from 'silal_app_base_react/src/data/repositories/authenticated_base_repository';
import { FeedbackToastHandler } from 'silal_app_base_react/src/config/errors/feedback';
import { API_BASE } from 'silal_app_base_react/src/config/constants';
import { AxiosInstance } from 'axios';
import { Promotion } from 'silal_app_base_react/src/data/types/promotions';

class PromotionsApiRepository extends AuthenticatedApiRepository {
  private static instance: PromotionsApiRepository | null = null;
  constructor(axiosInstance: AxiosInstance) {
    super(axiosInstance);
  }

  public static getInstance(
    axiosInstance: AxiosInstance,
  ): PromotionsApiRepository {
    if (!PromotionsApiRepository.instance) {
      PromotionsApiRepository.instance = new PromotionsApiRepository(
        axiosInstance,
      );
    }
    return PromotionsApiRepository.instance;
  }

  getPromotions = async (store_id: number) => {
    try {
      const res = await FeedbackToastHandler(
        this.sendRequest('GET', `/stores/${store_id}/listing_items_discounts/`),
        {
          noSuccessMsg: true,
          noFailureMsg: false,
        },
      );
      return res.data.promotions as Promotion[];
    } catch (e: any) {
      return false;
    }
  };

  createPromotion = async ({
    store_id,
    name_en,
    name_ar,
    img_id,
    item_ids,
    discount_type,
    discount_value,
    min_order_value,
    start_datetime,
    end_datetime,
  }: {
    store_id: number;
    name_en: string;
    name_ar: string;
    img_id: number | undefined;
    item_ids: number[];
    discount_type: string;
    discount_value: number;
    min_order_value: number;
    start_datetime: string;
    end_datetime: string;
  }) => {
    try {
      const res = await FeedbackToastHandler(
        this.sendRequest(
          'POST',
          `/stores/${store_id}/listing_items_discounts/create_discount/`,
          {
            baseApiUrl: API_BASE,
            data: {
              name_en,
              name_ar,
              img_id,
              item_ids,
              discount_type,
              discount_value,
              min_order_value,
              start_datetime,
              end_datetime,
            },
          },
        ),
        {
          noSuccessMsg: false,
          noFailureMsg: false,
          customSuccessMsg: 'Promotion Created Successfully!',
        },
      );
      return true;
    } catch (e: any) {
      return false;
    }
  };

  disablePromotion = async (store_id: number, promotion_id: string) => {
    try {
      await FeedbackToastHandler(
        this.sendRequest(
          'PUT',
          `/stores/${store_id}/listing_items_discounts/${promotion_id}/disable/`,
        ),
        {
          noSuccessMsg: false,
          noFailureMsg: false,
          customSuccessMsg: `Coupon disabled successfully!`,
        },
      );
      return true;
    } catch (e: any) {
      return false;
    }
  };

  enablePromotion = async (store_id: number, promotion_id: string) => {
    try {
      await FeedbackToastHandler(
        this.sendRequest(
          'PUT',
          `/stores/${store_id}/listing_items_discounts/${promotion_id}/enable/`,
        ),
        {
          noSuccessMsg: false,
          noFailureMsg: false,
          customSuccessMsg: `Coupon enabled successfully!`,
        },
      );
      return true;
    } catch (e: any) {
      return false;
    }
  };
}

const PromotionsRepository = PromotionsApiRepository.getInstance(
  sellerAxiosInstance as AxiosInstance,
);

export default PromotionsRepository;
